import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import getExerciseTypeVersionAdapter from './adapters';
import definitions from './definitions';
export * from './definitions';
export * from './interfaces';
export * from './flavors';
export const hasTypeDefinitions = type => type in definitions;
export const hasVersionDefinition = (type, version) => version in definitions[type];

// not possible yet to make this a combined type guard
export const hasSchemaDefinition = (type, version) => {
  if (!hasTypeDefinitions(type)) {
    return false;
  }
  return hasVersionDefinition(type, version);
};
export const getSchemaDefinition = (type, version) => {
  if (!hasTypeDefinitions(type)) {
    throw new TypeError("Type '".concat(type, "' does not exist."));
  }
  if (!hasVersionDefinition(type, version)) {
    throw new TypeError("Version '".concat(version, "' of type '").concat(type, "' does not exist."));
  }
  return definitions[type][version];
};
export const LATEST_SCHEMA_VERSION = {
  AiFirstCodingExercise: 'v0',
  ChatExercise: 'v2',
  CloudExercise: 'v1',
  DatalabExercise: 'v0',
  DragAndDropExercise: 'v2',
  ExplorableExercise: 'v2',
  GpuExercise: 'v0',
  IDEExercise: 'v3',
  MultiStepCodingExercise: 'v0',
  PromptingExercise: 'v0',
  PureMultipleChoiceExercise: 'v3',
  RemoteDesktopExercise: 'v5',
  VideoExercise: 'v1',
  VisualExercise: 'v1'
};

// use this to temporarily pin the version of an exercise type to migrate to
const LATEST_SAFE_TO_MIGRATE_SCHEMA_VERSION = _objectSpread({}, LATEST_SCHEMA_VERSION);
export const getLatestSchemaVersion = type => LATEST_SAFE_TO_MIGRATE_SCHEMA_VERSION[type];
export const isLatestSchemaVersion = (type, version) => getLatestSchemaVersion(type) === version;
export const migrateToLatestVersion = (type, version, data) => getExerciseTypeVersionAdapter(type, getLatestSchemaVersion(type))(type, version, data);
export const isInitialSchemaVersion = (type, version) => version === 'v0';
export { getExerciseTypeVersionAdapter };